import * as React from 'react'
import svgData from 'src/assets/data/icons.json'

const viewportDim = svgData.height
let viewportWidth = viewportDim

function SvgPath({ name }) {
    const path = svgData.icons.find(element => {
        return element.properties.name === name
    })
    viewportWidth = path?.icon.width ? path.icon.width : viewportDim

    return path
        ? path.icon.paths.map((p, index) => (
              <path key={index} d={p} style={path.icon.attrs[index]} />
          ))
        : null
}

class CustomIcon extends React.Component {
    render() {
        const { icon } = this.props
        return (
            <React.Fragment>
                <svg
                    viewBox={`0 0 ${viewportWidth} ${viewportDim}`}
                    className="custom-icon"
                    xmlns="http://www.w3.org/2000/svg"
                    xmlnsXlink="http://www.w3.org/1999/xlink"
                >
                    <SvgPath name={icon} />
                </svg>
            </React.Fragment>
        )
    }
}

export default CustomIcon
